import React, { useRef, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
// import Parse from "parse";
import {
  generateTitleFromFilename,
  getBase64FromUrl,
  getSecureUrl,
  sanitizeFileName,
} from "../../utils/general";
import { PencilIcon } from "@heroicons/react/24/outline";

function SignPad(props) {
  // console.log(props);
  const [penColor, setPenColor] = useState("blue");
  const allColor = ["blue", "red", "black"];
  const canvasRef = useRef(null);
  const [isDefaultSign, setIsDefaultSign] = useState(false);
  const [isTab, setIsTab] = useState("");
  const [isSignImg, setIsSignImg] = useState("");
  const [textWidth, setTextWidth] = useState(0);
  const [isDragOver, setIsDragOver] = useState(false);
  const [textHeight, setTextHeight] = useState(0);
  const [signatureType, setSignatureType] = useState("");
  const [isSignTypes, setIsSignTypes] = useState(true);
  const [typedSignature, setTypedSignature] = useState("");
  const fontOptions = [
    { value: "Fasthand" },
    { value: "Dancing Script" },
    { value: "Cedarville Cursive" },
    { value: "Delicious Handrawn" },
    // Add more font options as needed
  ];
  const [fontSelect, setFontSelect] = useState(fontOptions[0].value);
  const [isSavedSign, setIsSavedSign] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const accesstoken = localStorage.getItem("accesstoken") || "";
  //   const senderUser = localStorage.getItem(
  //     `Parse/${localStorage.getItem("parseAppId")}/currentUser`
  //   );
  //   const jsonSender = senderUser && JSON.parse(senderUser);
  const currentUserName = props?.userDetails?.name || "";

  // Mobile detection
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ) || window.innerWidth <= 768;

  const t = (key) => {
    const Texts = {
      draw: "Draw",
      type: "Type",
      typed: "Typed",
      upload: "Upload",
      default: "Default",
      initial: "Initial",
      signature: "Signature",
      initialType: "Initial Type",
      signatureType: "Signature Type",
      autoSign: "Auto Sign",
      clear: "Clear",
      save: "Save",
      autoSignMssg: "Auto Sign Message",
      "signature-tab": "Signature",
      "initial-teb": "Initial",
      "initial-type": "Initial Type",
      "signature-type": "Signature Type",
      "at-least-one-signature-type": "At least one signature type is required",
      "something-went-wrong-mssg": "Something went wrong",
      "upload-image": "Upload Image",
      "upload-stamp-image": "Upload Stamp Image",
    };
    return Texts[key] || key;
  };

  // Function to get optimal canvas dimensions for mobile
  const getCanvasDimensions = () => {
    if (isMobile) {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const maxWidth = Math.min(screenWidth - 80, 400); // Account for modal padding
      const maxHeight = Math.min(screenHeight * 0.4, 200); // 40% of screen height, max 200px
      return { width: maxWidth, height: maxHeight };
    }
    return { width: 400, height: 200 };
  };

  // Function to resize canvas for mobile
  const resizeCanvas = () => {
    if (canvasRef.current) {
      const canvas = canvasRef.current.getCanvas();
      const { width, height } = getCanvasDimensions();

      // Set canvas size
      canvas.width = width;
      canvas.height = height;

      // Set CSS size
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;

      // Clear and redraw if there's existing content
      if (isSignImg) {
        canvasRef.current.fromDataURL(isSignImg);
      }
    }
  };

  // Resize canvas on mount and window resize
  useEffect(() => {
    if (isTab === "draw" && canvasRef.current) {
      resizeCanvas();
    }

    const handleResize = () => {
      if (isTab === "draw" && canvasRef.current) {
        resizeCanvas();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isTab, isMobile]);

  // Prevent scrolling when drawing on mobile
  useEffect(() => {
    if (isTab === "draw" && isMobile) {
      const preventScroll = (e) => {
        if (
          e.target.closest(".signatureCanvas") ||
          e.target.closest(".intialSignatureCanvas")
        ) {
          e.preventDefault();
        }
      };

      document.addEventListener("touchmove", preventScroll, { passive: false });
      return () => document.removeEventListener("touchmove", preventScroll);
    }
  }, [isTab, isMobile]);

  useEffect(() => {
    handleTab();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signatureTypes]);
  function handleTab() {
    const signtypes = props?.signatureTypes || [];
    const defaultIndex = signtypes?.findIndex(
      (x) =>
        x.name === "default" &&
        x.enabled === true &&
        props.defaultSign &&
        (props?.currWidgetsDetails?.type || props.widgetType) !== "image" &&
        (props?.currWidgetsDetails?.type || props.widgetType) !== "stamp",
    );
    const getIndex =
      defaultIndex !== -1 // Check if the default index exists
        ? defaultIndex // If found, use it
        : signtypes?.findIndex((x) => x.enabled === true);

    if (getIndex !== -1) {
      setIsSignTypes(true);
      const tab = props?.signatureTypes[getIndex].name;
      if (tab === "draw") {
        setIsTab("draw");
        setSignatureType("draw");
      } else if (tab === "upload") {
        props?.setIsImageSelect(true);
        setIsTab("uploadImage");
      } else if (tab === "typed") {
        setIsTab("type");
      } else if (tab === "default") {
        setIsDefaultSign(true);
        setIsTab("mysignature");
      } else {
        setIsTab(true);
      }
    } else {
      setIsSignTypes(false);
    }
  }
  function isTabEnabled(tabName) {
    const isEnabled = props?.signatureTypes.find(
      (x) => x.name === tabName,
    )?.enabled;
    return isEnabled;
  }

  //function for clear signature image
  const handleClear = () => {
    if (isTab === "draw") {
      if (canvasRef.current) {
        canvasRef.current.clear();
      } else if (props?.isStamp) {
        props?.setImage("");
      }
      setIsSignImg("");
    } else if (isTab === "uploadImage") {
      props?.setImage("");
    }
  };
  //function for set signature url
  const handleSignatureChange = (data) => {
    props?.setSignature(data);
    setIsSignImg(data);
  };
  function base64StringtoFile(base64String, filename) {
    let arr = base64String.split(","),
      // type of uploaded image
      mime = arr[0].match(/:(.*?);/)[1],
      // decode base64
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const ext = mime.split("/").pop();
    const name = `${filename}.${ext}`;
    return new File([u8arr], name, { type: mime });
  }

  const uploadFile = async (file) => {
    alert("Uploadig file");
    // try {
    //   const parseFile = new Parse.File(file.name, file);
    //   const response = await parseFile.save();
    //   if (response?.url()) {
    //     const fileRes = await getSecureUrl(response.url());
    //     if (fileRes.url) {
    //     //   const tenantId = localStorage.getItem("TenantId");
    //     //   SaveFileSize(file.size, fileRes.url, tenantId);
    //       return fileRes?.url;
    //     } else {
    //       alert(`${t("something-went-wrong-mssg")}`);
    //       return false;
    //     }
    //   } else {
    //     alert(`${t("something-went-wrong-mssg")}`);
    //     return false;
    //   }
    // } catch (err) {
    //   // console.log("sign upload err", err);
    //   alert(`${err.message}`);
    //   return false;
    // }
  };

  // `handlesavesign` is used to save signaute, initials, stamp as a default
  const handleSaveSign = async () => {
    if (isSignImg || props?.image?.src) {
      setIsLoader(true);
      //   try {
      //     const User = Parse?.User?.current();
      //     const sanitizename = generateTitleFromFilename(User?.get("name"));
      //     const replaceSpace = sanitizeFileName(sanitizename);
      //     let file;
      //     if (isSignImg) {
      //       file = base64StringtoFile(isSignImg, `${replaceSpace}__sign`);
      //     } else {
      //       file = base64StringtoFile(props?.image?.src, `${replaceSpace}__sign`);
      //     }
      //     const imageUrl = await uploadFile(file);
      //     const userId = {
      //       __type: "Pointer",
      //       className: "_User",
      //       objectId: User?.id
      //     };
      //     if (imageUrl) {
      //       //  below code is used to save or update default signaute, initials, stamp
      //       try {
      //         const signCls = new Parse.Object("contracts_Signature");
      //         if (props?.saveSignCheckbox?.signId) {
      //           signCls.id = props.saveSignCheckbox.signId;
      //         }
      //         if (
      //           props.currWidgetsDetails?.type === "initials" ||
      //           props?.widgetType === "initials"
      //         ) {
      //           signCls.set("Initials", imageUrl);
      //         } else if (
      //           props.currWidgetsDetails?.type === "signature" ||
      //           props?.widgetType === "signature"
      //         ) {
      //           signCls.set("ImageURL", imageUrl);
      //         }
      //         signCls.set("UserId", userId);
      //         const signRes = await signCls.save();
      //         if (signRes) {
      //           // eslint-disable-next-line no-unused-expressions
      //           props.saveSignCheckbox.signId;
      //           props.setSaveSignCheckbox((prev) => ({
      //             ...prev,
      //             signId: signRes?.id
      //           }));
      //           const _signRes = JSON.parse(JSON.stringify(signRes));
      //           if (
      //             props.currWidgetsDetails?.type === "signature" ||
      //             props?.widgetType === "signature"
      //           ) {
      //             const defaultSign = await getBase64FromUrl(
      //               _signRes?.ImageURL,
      //               true
      //             );
      //             props.setDefaultSignImg(defaultSign);
      //           } else if (
      //             props.currWidgetsDetails?.type === "initials" ||
      //             props?.widgetType === "initials"
      //           ) {
      //             const defaultInitials = await getBase64FromUrl(
      //               _signRes?.Initials,
      //               true
      //             );
      //             props.setMyInitial(defaultInitials);
      //           }
      //           alert(t("saved-successfully"));
      //         }
      //         return signRes;
      //       } catch (err) {
      //         // console.log(err);
      //         alert(`${err.message}`);
      //       } finally {
      //         setIsLoader(false);
      //       }
      //     }
      //   } catch (err) {
      //     // console.log("Err while saving signature", err);
      //   }
    }
  };

  const handleSaveBtn = async () => {
    if (accesstoken && isSavedSign) {
      await handleSaveSign();
      resetToDefault();
    } else {
      resetToDefault();
    }
  };
  const resetToDefault = () => {
    props?.setCurrWidgetsDetails({});
    if (!props?.image) {
      if (isTab === "mysignature") {
        setIsSignImg("");
        if (props?.isInitial) {
          props?.onSaveSign(signatureType, "initials");
        } else {
          props?.onSaveSign(null, "default");
        }
      } else {
        if (isTab === "type") {
          setIsSignImg("");
          props?.onSaveSign(
            null,
            false,
            !props?.isInitial && textWidth > 150 ? 150 : textWidth,
            !props?.isInitial && textHeight > 35 ? 35 : textHeight,
            typedSignature,
          );
        } else {
          setIsSignImg("");
          const canvas = canvasRef.current?.getCanvas?.();
          let cw = canvas?.width || getCanvasDimensions().width;
          let ch = canvas?.height || getCanvasDimensions().height;
          if (props?.isInitial) {
            const side = Math.min(cw, ch);
            cw = side;
            ch = side;
          }
          canvasRef.current.clear();
          // Pass canvas size so onSaveSign can preserve aspect ratio (rectangle for signatures).
          props?.onSaveSign(signatureType, false, cw, ch);
        }
      }
      setPenColor("blue");
    } else {
      setIsSignImg("");
      props?.onSaveImage(signatureType);
    }
    props?.setIsSignPad(false);
    props?.setIsInitial && props?.setIsInitial(false);
    props?.setIsImageSelect(false);
    setIsDefaultSign(false);
    props?.setImage();
    handleTab();
    props?.setIsStamp(false);
  };
  //save button component
  const SaveBtn = () => {
    return (
      <div className="flex items-center space-x-3">
        {(isTab === "draw" || isTab === "uploadImage") && (
          <button
            type="button"
            onClick={() => handleClear()}
            className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            <svg
              className="h-4 w-4 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
            {t("clear")}
          </button>
        )}
        <button
          onClick={() => handleSaveBtn()}
          type="button"
          disabled={
            (isTab === "draw" && isSignImg) ||
            (isTab === "image" && props?.image) ||
            (isTab === "mysignature" && isDefaultSign) ||
            (isTab === "type" && typedSignature) ||
            props.isAutoSign
              ? false
              : props?.image
                ? false
                : true
          }
          className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary ${
            isSignImg ||
            props?.image ||
            isDefaultSign ||
            textWidth ||
            props.isAutoSign
              ? "bg-primary hover:bg-primary-dark"
              : "bg-gray-300 cursor-not-allowed"
          }`}
        >
          <svg
            className="h-4 w-4 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          {t("save")}
        </button>
      </div>
    );
  };
  const autoSignAll = () => {
    return (
      <label className="flex items-center space-x-2 text-sm text-gray-600">
        <input
          type="checkbox"
          checked={props.isAutoSign}
          onChange={(e) => {
            props.setIsAutoSign(e.target.checked);
          }}
          className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
        />
        <span>{t("auto-sign-mssg")}</span>
      </label>
    );
  };
  //useEffect for set already draw or save signature url/text url of signature text type and draw type for initial type and signature type widgets
  useEffect(() => {
    if (props?.currWidgetsDetails && canvasRef.current && props.isSignPad) {
      const isWidgetType = props?.currWidgetsDetails?.type;
      const signatureType = props?.currWidgetsDetails?.signatureType;
      const url = props?.currWidgetsDetails?.SignUrl;
      //checking widget type and draw type signature url
      if (props?.isInitial) {
        if (isWidgetType === "initials" && signatureType === "draw" && url) {
          canvasRef.current.fromDataURL(url);
        }
      } else if (
        isWidgetType === "signature" &&
        signatureType === "draw" &&
        url
      ) {
        canvasRef.current.fromDataURL(url);
      }

      const trimmedName = currentUserName && currentUserName?.trim();
      const firstCharacter = trimmedName?.charAt(0);
      const userName = props?.isInitial ? firstCharacter : currentUserName;
      const signatureValue = props?.currWidgetsDetails?.typeSignature;
      setTypedSignature(signatureValue || userName || "");
      setFontSelect("Fasthand");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isSignPad]);
  useEffect(() => {
    const loadFont = async () => {
      try {
        await document.fonts.load(`20px ${fontSelect}`);
        const selectFontSTyle = fontOptions.find(
          (font) => font.value === fontSelect,
        );
        setFontSelect(selectFontSTyle?.value || fontOptions[0].value);
      } catch (error) {
        console.error("Error loading font:", error);
      }
    };

    loadFont();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontSelect]);
  useEffect(() => {
    // Load the default signature after the component mounts
    if (canvasRef.current) {
      canvasRef.current.fromDataURL(isSignImg);
    }
    if (isTab === "type") {
      const trimmedName = typedSignature
        ? typedSignature?.trim()
        : currentUserName?.trim();
      const firstCharacter = trimmedName?.charAt(0);
      const userName = props?.isInitial ? firstCharacter : typedSignature;
      const signatureValue = props?.currWidgetsDetails?.typeSignature;
      setTypedSignature(signatureValue || userName || "");
      convertToImg(fontSelect, userName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTab]);
  //function for convert input text value in image
  const convertToImg = async (fontStyle, text, color) => {
    //get text content to convert in image
    const textContent = text;
    const fontfamily = fontStyle
      ? fontStyle
      : fontSelect
        ? fontSelect
        : "Fasthand";
    const fontSizeValue = "40px";
    //creating span for getting text content width
    const span = document.createElement("span");
    span.textContent = textContent;
    span.style.font = `${fontSizeValue} ${fontfamily}`; // here put your text size and font family
    span.style.color = color ? color : penColor;
    span.style.display = "hidden";
    document.body.appendChild(span); // Replace 'container' with the ID of the container element

    //create canvas to render text in canvas and convert in image
    const canvasElement = document.createElement("canvas");
    // Draw the text content on the canvas
    const ctx = canvasElement.getContext("2d");
    const pixelRatio = window.devicePixelRatio || 1;
    const addExtraWidth = props?.isInitial ? 10 : 50;
    const width = span.offsetWidth + addExtraWidth;
    const height = span.offsetHeight;
    setTextWidth(width);
    setTextHeight(height);
    const font = span.style["font"];
    // Set the canvas dimensions to match the span
    canvasElement.width = width * pixelRatio;
    canvasElement.height = height * pixelRatio;

    // You can customize text styles if needed
    ctx.font = font;
    ctx.fillStyle = color ? color : penColor; // Set the text color
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.scale(pixelRatio, pixelRatio);
    // Draw the content of the span onto the canvas
    ctx.fillText(span.textContent, width / 2, height / 2); // Adjust the x,y-coordinate as needed
    //remove span tag
    document.body.removeChild(span);
    // Convert the canvas to image data
    const dataUrl = canvasElement.toDataURL("image/png");
    props?.setSignature(dataUrl);
  };
  const PenColorComponent = (props) => {
    return (
      <div className="flex items-center space-x-3">
        {allColor.map((color, key) => (
          <button
            key={key}
            type="button"
            onClick={() => {
              props?.convertToImg &&
                props?.convertToImg(fontSelect, typedSignature, color);
              setPenColor(color);
            }}
            className={`p-2 rounded-full transition-colors duration-200 ${
              penColor === color
                ? "ring-2 ring-offset-2 ring-primary"
                : "hover:bg-gray-100"
            }`}
            aria-label={`Select ${color} color`}
          >
            <PencilIcon color={color} className="w-4 h-4" />
          </button>
        ))}
      </div>
    );
  };

  // `handleCancelBtn` function trigger when user click on cross button
  const handleCancelBtn = () => {
    setPenColor("blue");
    props?.setIsSignPad(false);
    props?.setIsInitial && props?.setIsInitial(false);
    props?.setIsImageSelect(false);
    setIsDefaultSign(false);
    props?.setImage();
    handleTab();
    props?.setIsStamp(false);
  };

  const savesigncheckbox = (
    <label className="flex items-center space-x-2 text-sm text-gray-600">
      <input
        type="checkbox"
        checked={isSavedSign}
        onChange={(e) => setIsSavedSign(e.target.checked)}
        className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
      />
      <span>Save {props?.currWidgetsDetails?.type || props?.widgetType}</span>
    </label>
  );
  return (
    <div>
      {props?.isSignPad && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            {/* Background overlay */}
            <div
              className="fixed inset-0 transition-opacity"
              aria-hidden="true"
            >
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            {/* Modal panel */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div
              className={`inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all ${
                isMobile
                  ? "w-[95%] max-h-[90vh] my-4"
                  : "sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              }`}
            >
              {isLoader && (
                <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                </div>
              )}

              {isSignTypes ? (
                <>
                  {/* Modal header */}
                  <div
                    className={`bg-white ${
                      isMobile
                        ? "px-3 pt-4 pb-3"
                        : "px-4 pt-5 pb-4 sm:p-6 sm:pb-4"
                    }`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                        <div className="flex justify-between items-center mb-4">
                          <h3 className="text-lg font-medium text-gray-900">
                            {props?.isStamp
                              ? props?.widgetType === "image" ||
                                props?.currWidgetsDetails?.type === "image"
                                ? t("upload-image")
                                : t("upload-stamp-image")
                              : props?.isInitial
                                ? t("initials")
                                : t("signature")}
                          </h3>
                          <button
                            type="button"
                            className="text-gray-400 hover:text-gray-500 focus:outline-none"
                            onClick={handleCancelBtn}
                          >
                            <span className="sr-only">Close</span>
                            <svg
                              className="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>

                        {/* Tabs */}
                        {!props?.isStamp && (
                          <div className="border-b border-gray-200">
                            <nav
                              className={`-mb-px flex ${
                                isMobile ? "space-x-4" : "space-x-8"
                              } overflow-x-auto`}
                              aria-label="Tabs"
                            >
                              {!props?.isInitial &&
                                props?.defaultSign &&
                                isTabEnabled("default") && (
                                  <button
                                    onClick={() => {
                                      setIsDefaultSign(true);
                                      props?.setIsImageSelect(true);
                                      setIsTab("mysignature");
                                      setSignatureType("");
                                      props?.setImage();
                                    }}
                                    className={`${
                                      isTab === "mysignature"
                                        ? "border-primary text-primary"
                                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                    } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                                  >
                                    {t("my-signature")}
                                  </button>
                                )}
                              {props?.isInitial &&
                                props?.myInitial &&
                                isTabEnabled("default") && (
                                  <button
                                    onClick={() => {
                                      setIsDefaultSign(true);
                                      props?.setIsImageSelect(true);
                                      setIsTab("mysignature");
                                      setSignatureType("");
                                      props?.setImage();
                                    }}
                                    className={`${
                                      isTab === "mysignature"
                                        ? "border-primary text-primary"
                                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                    } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                                  >
                                    {t("my-initials")}
                                  </button>
                                )}
                              {isTabEnabled("draw") && (
                                <button
                                  onClick={() => {
                                    setIsDefaultSign(false);
                                    props?.setIsImageSelect(false);
                                    setIsTab("draw");
                                    props?.setImage();
                                    if (isSignImg) {
                                      props?.setSignature(isSignImg);
                                    }
                                  }}
                                  className={`${
                                    isTab === "draw"
                                      ? "border-primary text-primary"
                                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                  } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                                >
                                  {t("draw")}
                                </button>
                              )}
                              {isTabEnabled("upload") && (
                                <button
                                  onClick={() => {
                                    setIsDefaultSign(false);
                                    props?.setIsImageSelect(true);
                                    setIsTab("uploadImage");
                                    setSignatureType("");
                                  }}
                                  className={`${
                                    isTab === "uploadImage"
                                      ? "border-primary text-primary"
                                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                  } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                                >
                                  {t("upload-image")}
                                </button>
                              )}
                              {isTabEnabled("typed") && (
                                <button
                                  onClick={() => {
                                    setIsDefaultSign(false);
                                    props?.setIsImageSelect(false);
                                    setIsTab("type");
                                    setSignatureType("");
                                    props?.setImage();
                                  }}
                                  className={`${
                                    isTab === "type"
                                      ? "border-primary text-primary"
                                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                  } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                                >
                                  {t("type")}
                                </button>
                              )}
                            </nav>
                          </div>
                        )}

                        {/* Modal content */}
                        <div className="mt-4">
                          {isDefaultSign ? (
                            <>
                              <div className="flex justify-center">
                                <div
                                  className={`${
                                    props?.isInitial
                                      ? "intialSignatureCanvas"
                                      : "signatureCanvas"
                                  } bg-white border border-primary flex flex-col justify-center items-center mb-2 cursor-pointer`}
                                >
                                  <img
                                    alt="stamp img"
                                    className="w-full h-full object-contain bg-white"
                                    draggable="false"
                                    src={
                                      props?.isInitial
                                        ? props?.myInitial
                                        : props?.defaultSign
                                    }
                                  />
                                </div>
                              </div>
                              {/* {props.setIsAutoSign && autoSignAll()} */}
                              <div className="flex justify-end mt-4">
                                <SaveBtn />
                              </div>
                            </>
                          ) : props?.isImageSelect || props?.isStamp ? (
                            !props?.image ? (
                              <div className="flex justify-center">
                                <div
                                  className={`${
                                    props?.isInitial
                                      ? "intialSignatureCanvas"
                                      : "signatureCanvas"
                                  } bg-white border-2 border-dashed ${
                                    isDragOver
                                      ? "border-blue-400 bg-blue-50"
                                      : "border-gray-300 hover:border-blue-400"
                                  } transition-colors duration-200 flex flex-col justify-center items-center mb-2 cursor-pointer px-6 py-8 rounded-lg`}
                                  onClick={() =>
                                    props?.imageRef.current.click()
                                  }
                                  onDragOver={(e) => {
                                    e.preventDefault();
                                    setIsDragOver(true);
                                  }}
                                  onDragLeave={(e) => {
                                    e.preventDefault();
                                    setIsDragOver(false);
                                  }}
                                  onDrop={(e) => {
                                    e.preventDefault();
                                    setIsDragOver(false);
                                    const files = e.dataTransfer.files;
                                    if (files.length > 0) {
                                      const file = files[0];
                                      if (file.type.startsWith("image/")) {
                                        const event = {
                                          target: { files: [file] },
                                        };
                                        props?.onImageChange(event);
                                      } else {
                                        // Handle non-image files
                                        console.log(
                                          "Please select an image file",
                                        );
                                      }
                                    }
                                  }}
                                >
                                  <input
                                    type="file"
                                    onChange={props?.onImageChange}
                                    className="filetype"
                                    accept="image/png,image/jpeg,image/jpg,image/gif,image/webp"
                                    ref={props?.imageRef}
                                    hidden
                                  />
                                  <div className="flex flex-col items-center space-y-3">
                                    <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center">
                                      <svg
                                        className="w-6 h-6 text-blue-500"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                        />
                                      </svg>
                                    </div>
                                    <div className="text-center">
                                      <p className="text-sm font-medium text-gray-700 mb-1">
                                        {t("upload-image") || "Upload Image"}
                                      </p>
                                      <p className="text-xs text-gray-500">
                                        {isDragOver
                                          ? "Drop your image here"
                                          : "Click to browse or drag and drop"}
                                      </p>
                                      <p className="text-xs text-gray-400 mt-1">
                                        PNG, JPG, GIF, WebP
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="flex justify-center">
                                  <div
                                    className={`${
                                      props?.isInitial
                                        ? "intialSignatureCanvas"
                                        : "signatureCanvas"
                                    } bg-white border border-primary mb-2 overflow-hidden`}
                                  >
                                    <img
                                      alt="print img"
                                      ref={props?.imageRef}
                                      src={props?.image.src}
                                      draggable="false"
                                      className="object-contain h-full w-full"
                                    />
                                  </div>
                                </div>
                                {/* {props.setIsAutoSign && autoSignAll()} */}
                                <div className="flex justify-end mt-4">
                                  <SaveBtn />
                                </div>
                              </>
                            )
                          ) : isTab === "type" ? (
                            <div>
                              <div className="flex justify-between items-center">
                                <span className="mr-2 text-sm">
                                  {props?.isInitial
                                    ? t("initial-teb")
                                    : t("signature-tab")}
                                  :
                                </span>
                                <input
                                  maxLength={props?.isInitial ? 3 : 30}
                                  style={{
                                    fontFamily: fontSelect,
                                    color: penColor,
                                  }}
                                  type="text"
                                  className="ml-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary text-lg"
                                  placeholder={
                                    props?.isInitial
                                      ? t("initial-type")
                                      : t("signature-type")
                                  }
                                  value={typedSignature}
                                  onChange={(e) => {
                                    setTypedSignature(e.target.value);
                                    convertToImg(fontSelect, e.target.value);
                                  }}
                                />
                              </div>
                              <div className="border border-gray-200 mt-4 rounded-md">
                                {fontOptions.map((font, ind) => (
                                  <div
                                    key={ind}
                                    style={{
                                      cursor: "pointer",
                                      fontFamily: font.value,
                                      backgroundColor:
                                        fontSelect === font.value
                                          ? "rgb(206 225 247)"
                                          : "transparent",
                                    }}
                                    onClick={() => {
                                      setFontSelect(font.value);
                                      convertToImg(font.value, typedSignature);
                                    }}
                                    className="hover:bg-gray-50"
                                  >
                                    <div
                                      className="py-2 px-3 text-lg"
                                      style={{ color: penColor }}
                                    >
                                      {typedSignature
                                        ? typedSignature
                                        : "Your signature"}
                                    </div>
                                  </div>
                                ))}
                              </div>

                              <div className="flex flex-col justify-between mt-4">
                                {/* {props.setIsAutoSign && autoSignAll()} */}
                                <div className="flex flex-row justify-between mt-4">
                                  <PenColorComponent
                                    convertToImg={convertToImg}
                                  />
                                  <SaveBtn />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="flex justify-center">
                                <SignatureCanvas
                                  ref={canvasRef}
                                  penColor={penColor}
                                  canvasProps={{
                                    className: `${
                                      props?.isInitial
                                        ? "intialSignatureCanvas"
                                        : "signatureCanvas"
                                    } border border-primary bg-white touch-none`,
                                    width: getCanvasDimensions().width,
                                    height: getCanvasDimensions().height,
                                  }}
                                  onEnd={() =>
                                    handleSignatureChange(
                                      canvasRef.current?.toDataURL(),
                                    )
                                  }
                                  dotSize={isMobile ? 2 : 1}
                                  minWidth={isMobile ? 2 : 1}
                                  maxWidth={isMobile ? 4 : 2}
                                  throttle={isMobile ? 16 : 0}
                                  style={{
                                    width: `${getCanvasDimensions().width}px`,
                                    height: `${getCanvasDimensions().height}px`,
                                    maxWidth: "100%",
                                    maxHeight: isMobile ? "200px" : "100px",
                                  }}
                                />
                              </div>
                              <div className="flex flex-col justify-between mt-4">
                                {/* {props.setIsAutoSign && autoSignAll()} */}
                                {accesstoken &&
                                  props?.saveSignCheckbox?.isVisible &&
                                  savesigncheckbox}
                                <div className="flex flex-row justify-between mt-4">
                                  <PenColorComponent />
                                  <SaveBtn />
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                      <div className="flex justify-between items-center">
                        <div className="text-lg font-medium text-gray-900">
                          {props?.isInitial ? "Initials" : "Signature"}
                        </div>
                        <button
                          type="button"
                          className="text-gray-400 hover:text-gray-500 focus:outline-none"
                          onClick={handleCancelBtn}
                        >
                          <span className="sr-only">Close</span>
                          <svg
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="mt-3">
                        <p className="text-sm text-gray-500">
                          {t("at-least-one-signature-type")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SignPad;
